import { NgClass } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { LayoutRefService } from '@metronic/app/core/_base/layout/services/layout-ref.service';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { HeaderDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/header.directive';
import { ToggleDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/toggle.directive';
import { FooterComponent } from '../../footer.component';
import { TopBarMenuComponent } from '../../nav/top-bar-menu.component';
import { ScrollTopComponent } from '../../scroll-top.component';
import { TopBarComponent } from '../../topbar.component';
import { Theme10BrandComponent } from './theme10-brand.component';

@Component({
    templateUrl: './theme10-layout.component.html',
    selector: 'theme10-layout',
    imports: [RouterLink, ToggleDirective, HeaderDirective, Theme10BrandComponent, TopBarComponent, TopBarMenuComponent, NgClass, RouterOutlet, FooterComponent, ScrollTopComponent]
})
export class Theme10LayoutComponent extends ThemesLayoutBaseComponent implements OnInit, AfterViewInit {

    @ViewChild('ktHeader', { static: true }) ktHeader: ElementRef;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        injector: Injector,
        _dateTimeService: DateTimeService,
        private layoutRefService: LayoutRefService
    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit() {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    }

    ngAfterViewInit(): void {
        this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
    }
}
